import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../Reducer/rootReducer';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';

let initialStore = {};
// const logger = createLogger();

const store = createStore(rootReducer, initialStore, applyMiddleware(thunk));

export { store };
